import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Menu, X, User, Wallet, Info, Edit, LogOut } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from '../context/AuthContext';

const Header = () => {
  const { isAuthenticated, user, loading, logout } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-sm border-b border-border">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="flex h-16 w-16 items-center justify-center rounded-2xl gradient-primary shadow-glow mx-auto mt-2 overflow-hidden">
              <img src="/favtransparent.png" alt="Logo" className="h-16 w-16 object-cover rounded-full" />
            </div>
            <span className="text-xl md:text-2xl font-bold bg-gradient-primary bg-clip-text text-transparent">
              VBetPro
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6">
            <Link to="/sports" className="text-foreground hover:text-primary transition-colors font-medium">
              Esportes
            </Link>
            <Link to="/casino" className="text-foreground hover:text-primary transition-colors font-medium">
              Cassino
            </Link>
            <Link to="/live-casino" className="text-foreground hover:text-primary transition-colors font-medium">
              Ao Vivo
            </Link>
            <Link to="/crash-games" className="text-foreground hover:text-primary transition-colors font-medium">
              Crash Games
            </Link>
          </nav>

          {/* CTA Buttons */}
          <div className="flex items-center space-x-4">
            <div className="hidden md:flex items-center space-x-4">
              {isAuthenticated ? (
                <>
                  <Button variant="ghost" size="sm" className="flex items-center gap-2">
                    <Wallet className="h-4 w-4" />
                    <span className="font-semibold">R$ 0,00</span>
                  </Button>
                  <DropdownMenu modal={false}>
                    <DropdownMenuTrigger asChild>
                      <Button variant="ghost" className="flex items-center gap-2">
                        <User className="h-4 w-4" />
                        {user?.nome}
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent className="w-56 z-50" align="end">
                      <DropdownMenuLabel>Minha Conta</DropdownMenuLabel>
                      <DropdownMenuSeparator />
                      <DropdownMenuItem asChild>
                        <Link to="/profile/edit">
                          <Edit className="h-4 w-4" />&nbsp;
                          Editar Perfil
                        </Link>
                      </DropdownMenuItem>
                      <DropdownMenuItem asChild>
                        <Link to="/profile">
                          <Info className="h-4 w-4" />&nbsp;
                          Minhas Informações
                        </Link>
                      </DropdownMenuItem>
                      <DropdownMenuSeparator />
                      <DropdownMenuItem onClick={logout} className="focus:bg-destructive focus:text-destructive-foreground">
                        <LogOut className="h-4 w-4" />&nbsp;
                        Sair
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </>
              ) : (
                <>
                  <Button variant="ghost" className="text-foreground hover:text-primary hover:bg-secondary" asChild>
                    <Link to="/login">Entrar</Link>
                  </Button>
                  {/*<Button className="bg-gradient-primary hover:shadow-glow transition-all duration-300" asChild>
                    <Link to="/register">Cadastrar</Link>
                  </Button>*/}
                </>
              )}
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden text-foreground"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-border animate-fade-in">
            <nav className="flex flex-col space-y-4">
              <Link to="/sports" className="text-foreground hover:text-primary transition-colors font-medium block w-full" onClick={() => setIsMenuOpen(false)}>
                Esportes
              </Link>
              <Link to="/casino" className="text-foreground hover:text-primary transition-colors font-medium block w-full" onClick={() => setIsMenuOpen(false)}>
                Cassino
              </Link>
              <Link to="/live-casino" className="text-foreground hover:text-primary transition-colors font-medium block w-full" onClick={() => setIsMenuOpen(false)}>
                Ao Vivo
              </Link>
              <Link to="/crash-games" className="text-foreground hover:text-primary transition-colors font-medium block w-full" onClick={() => setIsMenuOpen(false)}>
                Crash Games
              </Link>
              <div className="flex flex-col space-y-2 pt-4 border-t border-border">
                {isAuthenticated ? (
                  <>
                    <Button variant="outline" className="w-full flex items-center gap-2">
                      <Wallet className="h-4 w-4" />
                      <span className="font-semibold">R$ 0,00</span>
                    </Button>
                    <Button variant="outline" className="w-full" asChild>
                      <Link to="/profile/edit" onClick={() => setIsMenuOpen(false)} className="flex items-center gap-2">
                        <User className="h-4 w-4" />
                        Editar Perfil
                      </Link>
                    </Button>
                    <Button variant="outline" className="w-full" asChild>
                      <Link to="/profile" onClick={() => setIsMenuOpen(false)} className="flex items-center gap-2">
                        <User className="h-4 w-4" />
                        Minhas Informações
                      </Link>
                    </Button>
                    <Button variant="outline" className="w-full" onClick={() => { logout(); setIsMenuOpen(false); }}>
                      Sair
                    </Button>
                  </>
                ) : (
                  <>
                    <Button variant="outline" className="w-full" asChild>
                      <Link to="/login" onClick={() => setIsMenuOpen(false)}>Entrar</Link>
                    </Button>
                    <Button className="w-full bg-gradient-primary" asChild>
                      <Link to="/register" onClick={() => setIsMenuOpen(false)}>Cadastrar</Link>
                    </Button>
                  </>
                )}
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;